/**
 * 自定义埋点上报
 * 2026-07-02 13:00:00
 * @author 贾雪岩的大爷
 */

import { addUserDeed } from '@/api/deed'

/**
 * 上报用户行为埋点
 * @param {string} u_refer 当前网址
 * @param {number} e_type 事件类型
 * @param {string|object} [e_data=''] 事件内容，可为空
 * @returns {Promise<AxiosResponse<any>>}
 */
export function reportUserDeed(u_refer, e_type, e_data = '') {
  return addUserDeed({
    u_refer,
    e_type,
    e_data
  })
}

/**
 * 播放音乐/音效埋点上报
 * @param {number} materialType 素材类型：2音乐 3音效
 * @param {object} info 播放信息
 * @param {string|number} info.music_id 音乐/音效 id
 */
export function reportPlayDeed(materialType, info) {
  const deedTypeMap = {
    2: 3,
    3: 4
  }
  const e_type = deedTypeMap[materialType]
  const music_id = info?.music_id
  if (!e_type || !music_id) return
  reportUserDeed(window.location.href, e_type, music_id)
}

export function getTagDisplayName(tag) {
  if (typeof tag === 'string') return tag
  return tag?.label_name || tag?.name || ''
}

/**
 * 列表页标签选择埋点上报
 * @param {string|string[]|object|object[]} tagNames 标签名或标签对象
 */
export function reportTagSelectDeed(tagNames) {
  const e_data = (Array.isArray(tagNames) ? tagNames : [tagNames])
    .map(getTagDisplayName)
    .filter(Boolean)
    .join(',')
  if (!e_data) return
  reportUserDeed(window.location.href, 6, e_data)
}

const PAGE_VISIT_RULES = [
  { path: '/playList', e_type: 12 },
  { path: '/music', e_type: 13 },
  { path: '/soundEffect', e_type: 14 },
  { path: '/video', e_type: 15 },
  { path: '/picture', e_type: 16 },
  { path: '/all-play-list', e_type: 17 },
  { path: '/package/page', e_type: 18 },
  { name: 'musiceDetail', e_type: 19, getEData: (to) => to.params.id },
  { name: 'musiceDownDetail', e_type: 20, getEData: (to) => to.params.id }
]

/**
 * 页面访问埋点上报
 * @param {import('vue-router').Route} to 目标路由
 */
export function reportPageVisitDeed(to) {
  const rule = PAGE_VISIT_RULES.find((item) => {
    if (item.path) return to.path === item.path
    if (item.name) return to.name === item.name
    return false
  })
  if (!rule) return

  const e_data = rule.getEData ? rule.getEData(to) : ''
  if (rule.getEData && !e_data) return

  reportUserDeed(window.location.href, rule.e_type, e_data)
}
